export const SHOULD_ANIMATE = false
export const NAVBAR_HEIGHT = 142
